import { Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpBody01Primary } from 'components/atoms/customer-portal/typography';
import { FieldValueEditor } from './field-value-editor';
import { CpTaskDrawerFieldProps } from './types';

const LabelCol = styled(Col)`
  display: flex;
  align-items: center;
`;

const ValueCol = styled(Col)``;

const StyledRow = styled(Row)`
  margin-bottom: var(--cp-spacing-05);
  width: 100%;
  min-height: 42px;

  @media (max-width: 480px) {
    flex-direction: column;

    margin-bottom: var(--cp-spacing-06);

    .ant-col-6,
    .ant-col-18 {
      max-width: 100% !important;
      width: 100% !important;
      flex: 0 0 100% !important;
    }

    ${LabelCol} {
      width: 100%;
      margin-bottom: var(--cp-spacing-03);
    }

    ${ValueCol} {
      width: 100%;
    }
  }
`;

export const CpTaskDrawerField: React.FC<CpTaskDrawerFieldProps> = ({
  field,
  onChange,
}) => {
  return (
    <StyledRow>
      <LabelCol span={6}>
        <CpBody01Primary>{field?.fieldLabel}</CpBody01Primary>
      </LabelCol>
      <ValueCol span={18}>
        <FieldValueEditor field={field} onChange={onChange} />
      </ValueCol>
    </StyledRow>
  );
};
